var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataMigration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177,
    height: 181,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m134.115 151.2-.603 1.039-2.165-1.165.603-1.039 2.165 1.165Zm-17.49-133.621 1.43.773.604-1.04-1.43-.772-.604 1.039Zm2.506 1.356.604-1.04 2.165 1.166-.604 1.04-2.165-1.166Zm3.241 1.736.604-1.04 2.164 1.166-.603 1.04-2.165-1.166Zm3.254 1.748.604-1.039 2.164 1.166-.603 1.04-2.165-1.167Zm3.241 1.736.603-1.039 2.165 1.166-.603 1.04-2.165-1.167Zm3.241 1.75.603-1.04 2.165 1.166-.603 1.039-2.165-1.166Zm3.241 1.735.603-1.039 2.165 1.166-.604 1.039-2.164-1.166Zm3.254 1.749.603-1.04 2.165 1.166-.604 1.04-2.164-1.166Zm3.24 1.736.604-1.04 2.165 1.166-.604 1.04-2.165-1.166Zm3.241 1.748.604-1.039L147.853 33l-.604 1.04-2.165-1.167Zm3.254 1.736.604-1.039 2.165 1.166-.604 1.04-2.165-1.167Zm3.241 1.75.604-1.04 2.165 1.166-.604 1.039-2.165-1.166Zm3.241 1.735.604-1.039 2.164 1.166-.603 1.039-2.165-1.166Zm3.241 1.749.603-1.04 2.165 1.166-.603 1.04-2.165-1.166Zm3.254 1.736.603-1.04 2.165 1.166-.603 1.04-2.165-1.166Zm3.175 1.736c.617.418 1.115.95 1.548 1.558l1.024-.658a7.167 7.167 0 0 0-1.863-1.876l-.709.976Zm2.099 2.521a7.42 7.42 0 0 1 .656 2.104l1.221-.152a8.558 8.558 0 0 0-.761-2.458l-1.116.506Zm.722 3.194c-.026.747-.21 1.596-.315 2.306l1.22.177c.118-.747.302-1.634.328-2.433l-1.233-.05Zm-.499 3.497 1.221.177-.355 2.37-1.22-.177.354-2.37Zm-.538 3.548 1.221.177-.355 2.37-1.22-.177.354-2.37Zm-.537 3.548 1.22.178-.354 2.37-1.221-.178.355-2.37Zm-.538 3.548 1.22.178-.354 2.37-1.221-.178.355-2.37Zm-.538 3.536 1.22.177-.354 2.37-1.221-.178.355-2.37Zm-.538 3.547 1.22.178-.354 2.37-1.221-.178.355-2.37Zm-.538 3.549 1.22.177-.354 2.37-1.221-.178.355-2.37Zm-.538 3.548 1.22.177-.354 2.37-1.221-.178.355-2.37Zm-.538 3.548 1.22.177-.354 2.37-1.22-.178.354-2.37Zm-.538 3.548 1.22.177-.354 2.37-1.22-.178.354-2.37Zm-.538 3.548 1.22.177-.354 2.37-1.22-.178.354-2.37Zm-.538 3.548 1.22.177-.354 2.37-1.22-.178.354-2.37Zm-.538 3.548 1.22.177-.354 2.37-1.22-.178.354-2.37Zm-.538 3.548 1.22.177-.354 2.37-1.22-.178.354-2.37Zm-.538 3.548 1.22.177-.354 2.37-1.22-.178.354-2.369Zm-.538 3.548 1.22.177-.354 2.37-1.22-.178.354-2.369Zm-.538 3.548 1.22.177-.354 2.37-1.22-.178.354-2.369Zm-.538 3.548 1.22.177-.354 2.37-1.22-.177.354-2.37Zm-.538 3.548 1.22.177-.354 2.37-1.22-.177.354-2.37Zm-.538 3.548 1.221.177-.355 2.37-1.22-.177.354-2.37Zm-.538 3.548 1.221.177-.355 2.37-1.22-.177.354-2.37Zm-.538 3.548 1.221.177-.355 2.37-1.22-.177.354-2.37Zm-.538 3.548 1.221.178-.355 2.369-1.22-.177.354-2.37Zm-.538 3.548 1.221.178-.355 2.369-1.22-.177.354-2.37Zm-.538 3.548 1.221.178-.355 2.369-1.22-.177.354-2.37Zm-.537 3.548 1.22.178-.354 2.369-1.221-.177.355-2.37Zm-.538 3.548 1.22.178-.354 2.369-1.221-.177.355-2.37Zm-.552 3.548 1.221.178-.355 2.369-1.22-.177.354-2.37Zm-.537 3.548 1.22.178-.354 2.369-1.221-.177.355-2.37Zm-.525 3.548 1.22.178-.079.545a5.025 5.025 0 0 1-.708 1.951l-1.05-.634c.289-.443.446-.975.525-1.495l.092-.545Zm-1.286 2.763c-.538.393-1.194.507-1.863.367l-.25 1.166c1.011.203 2.008.025 2.848-.583l-.735-.95Zm-2.834 0-.604 1.039-2.165-1.166.604-1.039 2.165 1.166Zm-3.241-1.736-.604 1.039-2.165-1.166.604-1.039 2.165 1.166Zm-3.241-1.749-.604 1.039-2.165-1.166.604-1.039 2.165 1.166Zm-3.254-1.736-.604 1.039-2.164-1.166.603-1.039 2.165 1.166Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8D6DFC",
    d: "M103.452 2.69c1.128.608 1.784 1.305 2.519 2.306-.013-.178-.013.469-.013-.52 0-.988-.577-2.597.223-3.396.315-.316 1.876-.9 2.244-1 .708-.178 1.548-.064 2.427.405 1.351.71 2.559 2.09 3.451 3.763.892 1.673 1.443 4.448 1.43 5.449 0 1.001 0 .342-.013.52.748-.216 1.417-.216 2.585.405 1.154.62 2.611 2.142 3.516 3.84.905 1.698 1.47 3.687 1.483 5.537 0 1.445-.341 2.598-.919 3.396-.59.798-1.719 1.28-2.519 1.533-2.296.773-6.744-3.738-9.08-5.018-2.479-1.356-4.959-2.711-7.413-4.055-1.338-.735-2.545-2.129-3.398-3.788-.853-1.66-1.378-3.6-1.365-5.411.013-1.052-.787-2.636.25-3.396 1.587-1.179 3.306-1.255 4.592-.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M102.153 3.235c1.128.595 1.784 1.305 2.506 2.306-.013-.178-.013.469-.013-.52 0-.988.564-3.155 1.443-3.877.879-.723 2.099-.811 3.451-.102 1.351.71 2.558 2.091 3.451 3.764.892 1.672 1.443 4.448 1.43 5.449 0 1 0 .342-.013.52.748-.216 1.417-.216 2.585.405 1.154.62 2.611 2.141 3.516 3.84.905 1.697 1.47 3.674 1.483 5.537 0 1.862-.551 3.244-1.47 3.978-.905.723-2.152.799-3.529.038a2640.18 2640.18 0 0 0-7.519-4.105l-7.413-4.055c-1.338-.735-2.546-2.129-3.398-3.789-.853-1.66-1.378-3.599-1.365-5.41.013-1.813.564-3.143 1.443-3.865.88-.735 2.283-.71 3.412-.114Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m104.751 12.193-2.31-1.292 3.635 6.07 3.648-2.015-2.31-1.28.013-5.715-2.676-1.483v5.715Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m112.741 14.664 2.309 1.28-3.634-6.057-3.648 2.002 2.309 1.293-.013 5.702 2.664 1.495.013-5.715ZM43.935 19.403l.525-.912 1.89 1.014-.526.912-1.889-1.014Zm2.782 85.267-1.417-.76-.525.912 1.417.761.525-.913Zm-2.362-1.28-.525.913-1.89-1.014.526-.912 1.889 1.013Zm-2.834-1.508-.525.913-1.89-1.014.525-.912 1.89 1.013Zm-2.821-1.52-.525.912-1.89-1.014.525-.912 1.89 1.014Zm-2.834-1.52-.525.912-1.89-1.014.525-.912 1.89 1.013Zm-2.834-1.521-.525.912-1.89-1.014.525-.912 1.89 1.014ZM30.21 95.8l-.525.912-.971-.52a4.604 4.604 0 0 1-.945-.697l.761-.735c.184.177.473.406.709.52l.97.52Zm-2.283-1.775a4.81 4.81 0 0 1-.722-1.736l-1.063.19c.144.748.446 1.47.866 2.116l.919-.57Zm-.8-2.66c.025-.66.183-1.37.275-2.003l-1.063-.152c-.105.659-.262 1.432-.289 2.116l1.076.038Zm.445-3.042-1.063-.152.315-2.066 1.063.152-.315 2.066Zm.46-3.092-1.063-.152.315-2.066 1.062.153-.315 2.065Zm.472-3.092-1.063-.152.315-2.065 1.063.152-.315 2.065Zm.472-3.092-1.063-.152.315-2.065 1.063.152-.315 2.065Zm.473-3.091-1.063-.153.315-2.065 1.063.152-.315 2.066Zm.472-3.105-1.063-.152.315-2.066 1.063.153-.315 2.065Zm.46-3.092-1.064-.152.315-2.066 1.063.153-.315 2.065Zm.471-3.092-1.062-.152.315-2.065 1.062.152-.314 2.065Zm.473-3.092-1.063-.152.315-2.065 1.063.152-.315 2.065Zm.472-3.092-1.063-.152.315-2.065 1.063.152-.315 2.066Zm.46-3.091-1.063-.152.315-2.066 1.062.152-.315 2.066Zm.472-3.092-1.063-.152.315-2.066 1.063.152-.315 2.066Zm.472-3.105-1.063-.152.315-2.065 1.063.152-.315 2.065Zm.473-3.092-1.063-.152.315-2.065 1.062.152-.314 2.065Zm.459-3.091-1.063-.152.315-2.066 1.063.152-.315 2.066Zm.472-3.092-1.063-.152.315-2.066 1.063.152-.315 2.066Zm.472-3.092-1.062-.152.315-2.066 1.062.152-.315 2.066Zm.473-3.092-1.063-.152.315-2.066 1.063.153-.315 2.065Zm.459-3.092-1.063-.152.315-2.065 1.063.152-.315 2.065Zm.472-3.105-1.062-.151.314-2.066 1.063.152-.315 2.066Zm.473-3.091-1.063-.152.315-2.066 1.063.152-.315 2.066Zm.472-3.092-1.063-.152.315-2.066 1.063.152-.315 2.066Zm.46-3.092-1.063-.152c.105-.646.17-1.52.446-2.167l.997.406c-.236.52-.302 1.47-.38 1.913Zm.852-2.572c.42-.355.971-.419 1.483-.241l.354-.989c-.892-.304-1.85-.164-2.559.444l.722.786Zm2.375.19.525-.913 1.89 1.014-.526.912-1.889-1.013Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8E8C4",
    d: "m127.87 163.352-65.355-34.897c-1.6-.71-3.963-1.381-5.537-.456l-4.028 2.369c-.814.482-3.477 2.053-1.693 2.991 5.235 2.75 60.855 32.705 66.169 35.505 1.01.533 2.48.723 4.028.596 1.535-.127 3.136-.519 4.356-1.254l1.614-.963c1.141-.672 1.771-1.42 1.824-2.129.065-.685-.394-1.331-1.378-1.762Z",
    opacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M78.85 6.72c-.945-.52-2.047-.71-3.084-.33l-2.309.874c-.84 4.194 47.904 158.078 48.967 159.142l2.06-.747c1.352-.52 2.06-1.876 2.27-3.206l17.438-114.906v-.013c.288-1.938-.315-3.94-1.417-5.563-.591-.874-1.378-1.672-2.323-2.166L78.85 6.719Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M138.169 40.654 76.566 7.568c-2.506-1.343-4.907-.05-5.353 2.877L53.79 125.35c-.447 2.927 1.22 6.387 3.739 7.743l61.589 33.085c2.507 1.343 4.908.051 5.354-2.864l17.438-114.905c.446-2.94-1.234-6.412-3.74-7.755Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A9FF8",
    d: "M138.169 40.654 76.566 7.568c-2.506-1.343-4.907-.05-5.353 2.877l-.892 5.88 70.682 37.963.892-5.905c.46-2.914-1.22-6.386-3.726-7.73Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C68E5",
    d: "M76.055 15.716c-.787-.634-1.273-1.939-1.063-2.927.21-.989 1.024-1.28 1.811-.646.787.633 1.273 1.938 1.063 2.927-.21.988-1.024 1.28-1.81.646ZM81.08 18.681c-.787-.633-1.272-1.938-1.062-2.927.21-.988 1.023-1.28 1.81-.646.788.633 1.273 1.939 1.063 2.927-.197.988-1.01 1.267-1.81.646ZM86.12 21.634c-.788-.634-1.274-1.939-1.064-2.927.21-.989 1.024-1.28 1.811-.647.787.634 1.273 1.94 1.063 2.928-.197.988-1.01 1.28-1.81.646Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3856D8",
    d: "M134.456 68.531c-.275-.14-.538 0-.59.317-.053.33.131.71.407.862.288.152.551.012.59-.317a.837.837 0 0 0-.407-.862ZM64.404 84.13l.472.253 5.039-33.174-.473-.253-5.038 33.174Zm5.51-34.695c-.275-.14-.537 0-.59.33-.052.316.131.71.407.849.289.152.551.012.604-.317.052-.33-.132-.71-.42-.862Zm2.034 40.46.473.254 5.038-33.187-.472-.254-5.039 33.187Zm5.524-34.707c-.275-.152-.538 0-.59.317-.053.316.144.71.406.849.276.152.552 0 .591-.317.066-.317-.131-.697-.407-.849Zm3.477 30.957.486.253 5.025-33.174-.485-.254-5.026 33.175Zm5.524-34.695c-.275-.152-.55 0-.59.317-.053.316.144.71.42.861.275.14.538 0 .59-.316.04-.33-.144-.723-.42-.862Zm3.49 30.956.473.254 5.038-33.187-.472-.253-5.039 33.186ZM95.474 47.7c-.275-.152-.538 0-.59.33-.053.316.13.696.406.848.29.153.538 0 .59-.316.053-.33-.117-.71-.406-.862Zm2.52 37.293.472.253 5.038-33.174-.472-.254-5.039 33.175Zm5.523-34.708c-.275-.152-.538 0-.59.317-.053.317.144.71.407.849.275.152.551 0 .59-.317.052-.304-.131-.697-.407-.849Zm1.785 42.044.485.254 5.039-33.187-.486-.254-5.038 33.187Zm5.524-34.694c-.276-.14-.538-.013-.591.329-.052.317.144.697.407.849.289.152.551.013.59-.304.066-.342-.118-.722-.406-.874Zm1.561 43.628.472.253 5.039-33.174-.473-.253-5.038 33.174Zm5.524-34.708c-.276-.152-.551 0-.591.317-.052.317.145.71.42.862.276.152.538 0 .591-.317.039-.33-.145-.71-.42-.862Zm2.034 40.423.472.253 5.038-33.187-.472-.253-5.038 33.187Zm5.523-34.708c-.275-.152-.537 0-.59.317-.052.33.131.71.407.862.275.152.551 0 .59-.317.053-.33-.131-.71-.407-.862Zm3.478 30.957.485.253 5.038-33.186-.485-.254-5.038 33.187Z",
    opacity: 0.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#3856D8",
    d: "M137.462 71.8a.752.752 0 0 0-.315-.317c-.158-.089-.328-.089-.459 0a58.582 58.582 0 0 1-3.241 2.268 34.012 34.012 0 0 1-2.782 1.66c-4.015 2.117-6.915 2.269-9.775.735-2.795-1.558-5.498-4.84-9.027-9.453-3.936-5.17-7.426-8.667-10.93-10.542a13.197 13.197 0 0 0-1.561-.723c-4.041-1.609-8.135-1.051-13.055 1.622-.512.266-.998.545-1.496.824-3.779 2.116-7.322 4.093-11.153 2.04-1.994-1.064-4.054-3.218-6.272-7.007a.75.75 0 0 0-.315-.317c-.157-.089-.328-.089-.459.013-.223.177-.25.595-.052.925 2.466 4.245 4.75 6.627 6.94 7.805 4.12 2.205 7.9.089 11.94-2.166.5-.267.998-.545 1.496-.812 4.684-2.546 8.581-3.091 12.36-1.596.473.19.932.405 1.404.659 3.307 1.774 6.639 5.132 10.444 10.124 3.661 4.778 6.469 8.186 9.5 9.884.052.038.118.064.171.089 3.017 1.61 6.166 1.47 10.431-.76a34.175 34.175 0 0 0 2.847-1.698 71.433 71.433 0 0 0 3.267-2.307c.276-.202.302-.608.092-.95Z",
    opacity: 0.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#6BB6FF",
    d: "M136.805 69.355a.752.752 0 0 0-.315-.317c-.158-.076-.328-.089-.459.012a69.795 69.795 0 0 1-3.241 2.32 31.694 31.694 0 0 1-2.782 1.697c-4.015 2.167-6.915 2.357-9.775.862-2.795-1.52-5.498-4.765-9.014-9.339-3.936-5.12-7.426-8.566-10.93-10.39a16.783 16.783 0 0 0-1.548-.71c-4.041-1.546-8.135-.938-13.055 1.8-.512.265-.998.557-1.496.835-3.779 2.167-7.322 4.195-11.153 2.193-1.994-1.04-4.054-3.168-6.272-6.92a.831.831 0 0 0-.314-.316c-.158-.089-.329-.089-.46.013-.223.177-.25.595-.052.925 2.467 4.207 4.75 6.564 6.94 7.704 4.12 2.154 7.9-.025 11.94-2.331l1.496-.837c4.685-2.61 8.582-3.218 12.36-1.761.473.177.932.393 1.404.633 3.307 1.724 6.639 5.044 10.445 9.973 3.66 4.727 6.468 8.097 9.499 9.757.053.025.118.063.171.089 3.017 1.571 6.166 1.394 10.431-.9a35.28 35.28 0 0 0 2.847-1.736 74.04 74.04 0 0 0 3.267-2.344c.249-.152.263-.558.066-.912Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0FF",
    d: "M136.031 69.05c-1.915 1.458-3.897 2.852-6.022 4.017-4.015 2.167-6.915 2.357-9.775.862-2.795-1.52-5.498-4.764-9.014-9.339-3.123-4.042-7.466-9.174-12.478-11.1-5.38-2.066-9.894-.026-14.551 2.636-3.78 2.166-7.322 4.194-11.153 2.192-1.995-1.04-4.054-3.168-6.272-6.919a.83.83 0 0 0-.315-.317c.63 1.559 3.438 6.184 6.167 7.603 4.12 2.154 7.663.266 11.704-2.04 4.5-2.47 9.145-4.701 14.354-2.712 4.724 1.825 9.263 7.147 12.203 10.961 3.66 4.727 6.284 7.958 9.329 9.605 2.532 1.369 4.657 1.293 6.888.495 2.335-.85 7.741-4.144 8.935-5.944Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M100.211 77.4 63.997 58.027 58.92 91.454l36.555 19.565c2.559 1.368 5.012.063 5.459-2.928l3.083-22.808c.459-2.978-1.247-6.514-3.805-7.882Z",
    opacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#E5EDFF",
    d: "m99.542 84.472-3.517 23.062.42.051 1.155-.431c1.26-.482 1.928-1.749 2.112-2.978l2.808-20.82v-.012c.262-1.8-.302-3.675-1.325-5.17-.551-.81-1.273-1.546-2.165-2.015L52.923 51.462c-.879-.481-1.903-.659-2.873-.304l-1.01.38c-.512.19-.67.33-.67.368.486 4.308 51.854 28.143 51.172 32.566Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1E7FF",
    d: "M97.875 76.59 51.768 51.906c-1.023-.545-2.033-.621-2.86-.304-1.076.405-1.876 1.457-2.113 2.99L43.975 75.4c-.42 2.724 1.141 5.956 3.477 7.197l46.12 24.684c2.335 1.255 4.566.051 4.985-2.673l2.808-20.82c.407-2.724-1.154-5.943-3.49-7.197Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M98.74 85.27 72.474 71.32c-.25-.127-.486-.152-.682-.076-.263.101-.447.342-.499.71l-.17 1.026c-.106.646.275 1.419.826 1.723l26.268 13.951c.564.304 1.09.013 1.194-.633l.17-1.026c.093-.66-.288-1.42-.84-1.724ZM97.783 91.555 71.515 77.591c-.249-.127-.485-.152-.682-.076-.262.101-.446.342-.498.71l-.171 1.026c-.105.646.275 1.42.826 1.723L97.26 94.926c.564.304 1.089.012 1.194-.634l.17-1.026c.092-.647-.275-1.42-.84-1.711ZM81.015 89.25 70.57 83.875c-.25-.126-.486-.152-.683-.076-.262.102-.446.343-.498.71l-.17 1.026c-.106.647.275 1.42.826 1.724l10.444 5.372c.564.304 1.089.013 1.194-.633l.17-1.027c.092-.658-.275-1.431-.84-1.723Z",
    opacity: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#22D2FB",
    d: "M47.517 64.881c-.813 7.02 3.228 15.612 9.014 19.16 5.8 3.548 11.35-1.027 11.967-6.31.603-5.285-.42-7.49-2.074-10.974-1.01.532-2.02 1.077-3.03 1.596 1.075 2.243 1.732 3.675 1.351 7.071-.394 3.396-3.963 6.336-7.689 4.055-3.726-2.28-6.311-7.793-5.8-12.304a312.19 312.19 0 0 0-3.739-2.294Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#12A3EB",
    d: "M51.638 57.76c-2.165 1.14-3.714 3.599-4.12 7.122 1.246.773 2.519 1.533 3.752 2.293.263-2.255 1.247-3.84 2.637-4.574-.747-1.61-1.508-3.219-2.27-4.84Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C8DF3",
    d: "M59.483 58.558c-2.9-1.774-5.681-1.951-7.846-.81a554.833 554.833 0 0 0 2.27 4.853c1.39-.735 3.188-.621 5.038.52 1.85 1.14 3.45 3.09 4.487 5.309 1.01-.533 2.021-1.052 3.031-1.597-1.613-3.472-4.08-6.5-6.98-8.275Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M115.852 116.201c-5.314-4.093-8.49-12.582-7.099-18.982 1.391-6.399 6.823-8.261 12.137-4.169 5.314 4.093 8.489 12.596 7.098 18.982-1.39 6.387-6.836 8.262-12.136 4.169Z",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0E7FF",
    d: "M109.934 92.632c.971-.975 3.385-1.533 4.749-1.596 1.588-.076 3.359.545 5.105 1.939 4.605 3.662 7.36 11.277 6.153 17.005-.354 1.698-1.01 3.066-1.902 4.004-.84.874-3.556 1.977-4.803 2.065-7.518 1.014-12.15-20.553-9.302-23.417Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M113.581 114.174c-4.605-3.662-7.361-11.278-6.154-17.006 1.207-5.727 5.918-7.4 10.523-3.738 4.606 3.662 7.361 11.278 6.154 17.006-1.207 5.727-5.918 7.4-10.523 3.738Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m120.365 100.185 1.246.861-9.053 8.389-3.412-8.642 1.667.925 2.23 3.066 7.322-4.599Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m131.596 133.359-54.688-29.233c-.997-.533-1.968-.609-2.781-.305-1.05.393-1.824 1.407-2.047 2.902l-3.792 25.964c-.407 2.649 1.102 5.778 3.372 6.995l50.319 26.902c.551-.203 3.214-.659 3.359-1.42l6.258-31.805Z",
    opacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0E7FF",
    d: "m135.191 141.063-4.264 26.851.393.051 1.063-.406c.052-.025.105-.038.157-.063h.014c1.167-.443 1.784-1.622 1.955-2.762l3.621-24.773v-.013c.249-1.66-.276-3.396-1.22-4.79-.512-.747-1.181-1.432-2.008-1.875l-55.226-29.525c-.813-.443-1.771-.608-2.65-.291l-.945.354c-.105.038-.184.076-.25.102-.406.152-.537.279-.537.304.433 3.991 60.514 32.743 59.897 36.836Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "m133.642 133.752-55.225-29.525c-.945-.507-1.877-.583-2.65-.292-.998.381-1.746 1.344-1.956 2.763l-3.621 24.773c-.38 2.521 1.063 5.512 3.228 6.665l55.225 29.525c2.165 1.153 4.238.05 4.619-2.471l3.621-24.773c.368-2.509-1.076-5.5-3.241-6.665Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0E7FF",
    d: "M73.365 122.93c.617-3.497 2.034-4.675 3.832-4.194.275.076.564.19.853.355 1.77.976 3.569 3.51 3.844 7.742.17 2.674.709 5.132 3.03 6.412 6.115 3.155 3.911-15.535 9.697-12.355 4.986 2.75 2.008 12.685 3.937 18.97.669 2.179 1.889 3.206 2.729 3.674 3.516 1.812 3.91-3.915 4.369-6.323 2.126-11.138 3.464-11.759 5.616-10.568 2.243 1.255 3.241 2.116 2.821 13.749-.171 4.752 0 9.022 3.464 11.024 3.87 2.129 4.211-2.243 5.93-4.372 1.024-1.267 2.349-1.52 3.556-.861 1.312.722 2.48 2.521 2.992 5.309.852 4.663.459 11.126.21 13.369l-58.27-31.857c.511-3.408.853-7.058 1.39-10.074Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "m66.962 103.15-9.066-4.816-3.923 25.876 9.171 4.866c2.559 1.368 4.986.063 5.445-2.915l2.178-15.155c.46-2.965-1.246-6.488-3.805-7.856Z",
    opacity: 0.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0E7FF",
    d: "m66.36 110.132-2.704 16.118.42.051 1.155-.431c1.26-.482 1.929-1.749 2.112-2.978l2.008-13.875v-.013c.262-1.799-.302-3.675-1.326-5.17-.55-.811-1.272-1.546-2.164-2.015l-17.674-9.364c-.88-.482-1.903-.659-2.874-.304l-1.01.38c-.512.19-.67.33-.67.367.486 4.283 23.408 12.811 22.726 17.234Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m64.692 102.237-17.674-9.364c-1.023-.545-2.033-.62-2.86-.317-1.076.406-1.876 1.457-2.113 2.99l-2.007 13.876c-.407 2.725 1.142 5.956 3.477 7.198l17.674 9.364c2.335 1.254 4.566.051 4.986-2.674l2.007-13.875c.407-2.712-1.141-5.943-3.49-7.198Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M61.61 107.294c-.185 1.178-1.142 1.71-2.153 1.178-1.036-.558-1.692-1.951-1.509-3.13.184-1.178 1.129-1.685 2.165-1.14.998.532 1.667 1.913 1.496 3.092Zm-5.551 10.492c.184-1.179 1.128-1.698 2.165-1.141 1.01.545 1.68 1.926 1.496 3.105-.184 1.178-1.142 1.71-2.152 1.178-1.037-.557-1.693-1.964-1.509-3.142Zm-6.324-10.1c-.184 1.179-1.155 1.673-2.165 1.141s-1.68-1.926-1.496-3.092c.184-1.179 1.142-1.711 2.152-1.179.997.533 1.68 1.952 1.509 3.13Zm10.601-4.992c-1.718-.925-3.372-.064-3.673 1.951v.152l-5.997.913c-.42-1.128-1.22-2.104-2.204-2.636-1.719-.925-3.346-.038-3.66 1.964-.303 1.989.826 4.359 2.558 5.284.997.532 1.942.469 2.624-.076l4.842 6.741-.04.114c-.302 2.015.853 4.372 2.585 5.297 1.706.912 3.346.051 3.648-1.964.301-1.989-.853-4.384-2.559-5.297-1.22-.659-2.401-.405-3.096.494l-4.58-6.449c.118-.228.184-.52.236-.824a3.3 3.3 0 0 0 .04-.95l5.707-.938c.342 1.457 1.26 2.826 2.493 3.485 1.706.912 3.346.038 3.661-1.965.276-2.027-.892-4.384-2.585-5.296Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "m146.671 42.441-19.904-9.985-2.073.963-2.913 20.477c-.433 2.851 1.194 6.222 3.634 7.527l13.436 7.109 2.283-.85 5.537-25.241Z",
    opacity: 0.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0E7FF",
    d: "m158.768 39.78-5.156 33.01.446.05 1.207-.456c1.312-.507 2.007-1.825 2.204-3.118l4.422-30.677v-.013c.276-1.875-.315-3.84-1.378-5.41-.577-.85-1.338-1.623-2.27-2.104L134.744 18.63c-.919-.507-1.994-.684-2.992-.33l-1.062.406c-.538.19-.696.355-.696.38.499 4.511 29.483 16.068 28.774 20.693Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m157.036 31.544-23.5-12.431c-1.076-.57-2.126-.66-2.992-.33-1.128.418-1.968 1.52-2.204 3.117l-4.422 30.678c-.433 2.851 1.194 6.222 3.635 7.527l23.499 12.431c2.441 1.305 4.776.05 5.209-2.788l4.422-30.678c.42-2.85-1.207-6.221-3.647-7.526Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "m157.037 31.544-23.5-12.431c-1.076-.57-2.126-.66-2.992-.33-1.128.418-1.968 1.52-2.204 3.117l-3.516 24.419 32.356 17.119 3.516-24.368c.407-2.85-1.22-6.221-3.66-7.526Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D6AFD",
    d: "M127.37 50.424c.079-.57.525-.824.997-.558l10.641 5.576c.473.266.788.937.709 1.508l-.157 1.127c-.079.57-.525.824-.998.558l-10.641-5.576c-.472-.266-.787-.937-.708-1.508l.157-1.127ZM126.687 55.366c.066-.507.459-.722.879-.494 6.036 3.155 15.916 8.312 21.952 11.48.406.228.695.824.616 1.33l-.131.99c-.066.506-.459.721-.879.493-6.036-3.155-15.916-8.312-21.951-11.48-.407-.228-.696-.824-.617-1.33l.131-.99Z",
    opacity: 0.25
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#4A9EF8",
    d: "M153.375 38.056 150.62 57.85l5.261 2.864 2.756-19.793-5.262-2.864Zm-14.958-14.61-3.687 26.496 5.262 2.864 3.687-26.496-5.262-2.864Zm7.256 8.832 5.262 2.864-3.057 21.96-5.262-2.864 3.057-21.96ZM129.6 25.866l5.262 2.864-2.756 19.793-5.261-2.864 2.755-19.793Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#4164F3",
    d: "M128.472 33.621c-.144-.139-.092-.367.092-.507.197-.139.472-.151.604-.012l4.723 4.574 2.467.913 5.76-1.483 3.897-3.865c.17-.164.446-.215.616-.101.04.025.066.05.079.076l6.849 7.844 4.711.849c.236-.026.42.114.393.316-.013.203-.223.38-.472.393l-4.92-.824c-.145.013-.276-.025-.355-.113l-6.691-7.654-3.622 3.573a.569.569 0 0 1-.262.14l-6.075 1.57a.453.453 0 0 1-.289-.012l-2.637-.976a.311.311 0 0 1-.144-.076l-4.724-4.625Z",
    opacity: 0.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M128.459 33.723c-.131-.165-.092-.431.105-.596.197-.165.473-.177.604-.013l4.605 5.424 2.441 1.102L142 37.955l3.989-4.486c.17-.19.446-.24.616-.114.04.026.066.064.079.089l6.285 9.035 5.38-.545c.236-.026.42.14.393.38a.534.534 0 0 1-.472.456l-5.59.57c-.144.013-.275-.025-.341-.139l-6.127-8.82-3.7 4.157a.516.516 0 0 1-.263.165l-6.101 1.774a.452.452 0 0 1-.289-.013l-2.611-1.178a.275.275 0 0 1-.144-.102l-4.645-5.461Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "m69.01 22.698 9.945 4.41c2.375 1.33 3.083 5.613 2.69 8.477l-2.021 14.382c-.394 2.864-2.637 4.118-5.012 2.788L65.61 47.47l.354-2.382 3.044-22.391Z",
    opacity: 0.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0E7FF",
    d: "M43.987 12.104c.132-.963-.144-1.545.355-2.09.315-.342 1.312-.799 1.732-.95.8-.292 1.771-.203 2.755.354l28.433 16.055c2.296 1.28 3.844 4.562 3.477 7.324l-1.955 13.876c-.118.861-.446 1.963-1.207 2.597-.538.444-1.443.912-2.073.988-.656.076-.827-.494-1.548-.9L45.509 33.305c-2.296-1.28-3.844-4.562-3.477-7.324l1.956-13.876Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.214 12.548c.38-2.762 2.532-3.966 4.828-2.686L76.49 25.917c2.296 1.28 3.844 4.561 3.477 7.324L78.01 47.116c-.38 2.763-2.546 3.966-4.829 2.687L44.736 33.748c-2.296-1.28-3.844-4.562-3.477-7.324l1.955-13.876Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M43.214 12.548c.38-2.762 2.532-3.966 4.828-2.686l28.446 16.055c2.296 1.28 3.845 4.561 3.477 7.324l-.184 1.305a9.685 9.685 0 0 0-.76-.494l-35.978-20.3.17-1.204Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D6AFD",
    d: "M48.239 21.038c2.9.646 5.117 3.966 4.972 7.438-.157 3.472-2.624 5.766-5.523 5.12-2.9-.634-5.118-3.967-4.973-7.439.157-3.459 2.624-5.753 5.524-5.119Z",
    opacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M48.108 23.94c1.562.342 2.756 2.141 2.677 4.017-.079 1.875-1.417 3.104-2.979 2.762-1.561-.342-2.755-2.142-2.676-4.017.078-1.875 1.417-3.104 2.978-2.762Zm-.066 1.584c-.826-.178-1.535.468-1.574 1.47-.04.988.59 1.951 1.417 2.128.827.178 1.535-.468 1.575-1.47.039-.988-.59-1.938-1.418-2.128Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D6AFD",
    d: "M54.944 27.716c.105-.735.682-1.052 1.286-.697l18.566 10.175c.603.355 1.023 1.242.918 1.977l-.197 1.457c-.105.735-.682 1.052-1.285.697L55.664 31.15c-.616-.355-1.023-1.242-.918-1.977l.197-1.457ZM54.222 33.09c.066-.432.394-.622.761-.42l10.97 6.007c.354.203.603.735.55 1.166l-.118.862c-.065.43-.393.62-.76.418l-10.97-6.006c-.354-.203-.603-.735-.55-1.166l.117-.862Z",
    opacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M46.323 11.332c.63.139 1.116.861 1.09 1.622-.04.76-.578 1.254-1.208 1.115-.63-.14-1.115-.862-1.089-1.622.026-.76.565-1.255 1.207-1.115ZM49.197 12.928c.63.14 1.116.862 1.09 1.622-.04.76-.578 1.255-1.208 1.115-.63-.14-1.115-.862-1.089-1.622.026-.76.578-1.254 1.207-1.115ZM52.307 14.677c.63.14 1.115.862 1.089 1.622-.04.76-.578 1.255-1.207 1.115-.63-.14-1.116-.862-1.09-1.622.04-.76.578-1.254 1.208-1.115Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8E8C4",
    d: "m1.948 147.475 20.587-11.316c2.244-.988 5.458-1.774 7.741-.634 2.087 1.052 5.511 3.194 7.033 4.03 1.155.634 5.157 2.952 2.664 4.258-7.335 3.852-14.578 8.173-22.03 12.088-1.404.735-3.464 1.001-5.63.837-2.151-.178-4.355-.773-6.1-1.749-1.234-.697-2.454-1.381-3.648-2.053-1.614-.912-2.467-1.977-2.559-2.978-.078-.975.565-1.875 1.942-2.483Z",
    opacity: 0.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M50.968 75.614a2.994 2.994 0 0 1-.486-.114c.184-.025.328-.05.42-.063.735-.406 1.129-.596 1.968-1.216-.59-1.154-2.06.037-2.348.063-.118.012-.88-.127-1.627-.152-1.063-.05-1.732.164-2.454.95-.341.228-.722.507-1.102.798.092.964.223 1.774.827 2.623.196-.088.393-.139.577-.152.748-.076 1.47.09 3.136.621 1.68.545 1.981.52 4.579-1.28 1.902-1.317 2.939-2.065 2.611-3.04-.748-2.269-3.753.645-6.101.962Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M50.758 77.997c-1.614-.254-2.755-1.546-4.08-.786-.328.19-.643.38-.932.57.105.24.25.494.42.735.197-.089.394-.14.577-.152.748-.076 1.47.089 3.136.62 1.68.546 1.981.52 4.58-1.279 1.285-.887 2.164-1.52 2.519-2.129.17-.304-.328-.633-.735-.354-2.086 1.444-3.136 2.458-5.485 2.775Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M56.531 74.664c-.708.52-4.448 2.18-5.314 2.015-.236-.05-.196-.482-.223-1.027-.183.355.04 1.166-.315.989-2.007-.989-2.873-1.166-4.028-.456.8-.178 1.549-.076 2.283.164.696.228 1.339.621 2.087.824 1.941-.558 3.11-.748 5.51-2.509Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M29.778 84.674c-.407-.38-.787-.785-1.05-1.026-2.033-1.825-5.38-7.73-7.255-16.536.682-.533 2.69-1.04 3.057-1.115 1.587-.305 2.926.506 3.385 1.026.84.963 1.706 2.712 2.23 5.525.355 1.888 1.811 4.41 2.795 6.754.04.101.092.202.132.304 1.653-.85 3.424-1.546 4.33-1.901 1.968-.76 4.198-1.47 6.626-2.154.288-.076.55.101.84.025.157-.063.865-.304.996-.367-.013 1.394.394 2.496 1.181 3.396-.144.05-.931.392-1.089.456-.236.114-.512.456-.695.646-1.824 1.812-7.072 4.537-11.914 5.968-1.64.482-2.873.216-3.569-1Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#3469C0",
    d: "M29.778 84.674c-.407-.38-.787-.785-1.05-1.026-2.033-1.825-5.38-7.73-7.255-16.536 4.054-3.18 7.925 2.078 8.594 5.6.866 4.575 1.706 8.465 1.745 13.192-.892-.051-1.575-.431-2.034-1.23Z",
    opacity: 0.35
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#193161",
    d: "M11.08 141.722c-.118.393-.053.722-.25 1.229-.196.52-.432 1.09-.656 1.977-.34 1.381.132 3.231-.328 5.183-.236.785-.223 1.406.315 2.091.525.671 1.522 1.761 2.808 1.723a2.016 2.016 0 0 0 1.365-.634c.485-.545.892-1.33.813-2.319-.026-.367-.249-1.571-.21-2.661.04-.963.21-1.482.197-2.534-.026-1.115-.118-2.636-.131-3.358l-3.923-.697ZM22.496 136.033c-.38.988-.617 1.406-.643 2.775.236.722.761 1.013 1.351 1.52l.42.089c1.024.532 1.404 2.42 2.362 3.282.67.608 2.008.938 3.346 1.178 1.417.267 2.768-.126 2.401-1.203-.918-2.687-4.894-5.715-4.986-8.706l-4.251 1.065Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M28.465 116.911c-.105 5.145-1.26 14.762-1.089 19.831-1.364 1.318-4.08.912-4.973-.444-.55-4.663-1.194-11.277-1.26-13.837-.052-2.129.145-4.08.71-5.994-.788-5.626-4.16-13.292-3.36-18.589.355-2.319 1.93-4.828 2.389-6.741 3.962 4.714 6.993 2.458 8.633 2.053-.013 1.634.118 1.419.066 3.13a802.201 802.201 0 0 1-.788 17.993c.014.887-.065 1.876-.328 2.598Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2353",
    d: "M21.498 127.34c-.183-2.028-.315-3.789-.34-4.879-.053-2.129.143-4.08.708-5.994-.788-5.626-4.16-13.292-3.36-18.589.355-2.319 1.93-4.828 2.389-6.741 3.962 4.714 6.993 2.458 8.633 2.053v.481l-5.196 3.713 1.286-.279c-.052 6.678-.905 12.773-1.036 19.35-1.339 3.738-2.126 6.931-3.058 10.771l-.026.114Z",
    opacity: 0.3
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M19.623 120.649c-.958 5.145-3.74 17.614-4.41 22.682-1.718.925-3.91.444-4.513-.912-.026-4.663 0-13.039.355-15.599.301-2.129 1.075-5.411 1.955-7.324-.355-12.013-1.745-15.206-.066-20.502.735-2.32 2.664-4.562 3.45-6.488 1.064 1.584 2.704 3.814 6.233 3.548.341-.026 3.28-2.053 4.251-2.281-1.233 7.147-4.762 16.473-6.481 24.266-.145.899-.394 1.888-.774 2.61Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M25.12 65.883c.393.05.735.164 1.102.354 2.624 1.407 3.53 5.538 3.95 9.15.367 3.142.091 5.74-.014 8.616-.079 2.293.223 4.41.118 6.576-.026.647-.288 1.344-.354 2.028 0 .494-.184.976-.17 1.356-1.313 4.828-13.699 5.22-15.51 1.964.132-.482.276-.963.315-1.457-1.167-1.027-.498-3.523-.682-5.272-.144-1.305-.328-2.648-.735-3.611-1.68-4.004-4.04-7.096-4.5-10.175-.328-2.117 2.48-4.752 6.18-6.894 3.555-2.052 8.384-3.18 10.3-2.635Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#70B4F5",
    d: "M30.171 75.5c-1.312 1.293-9.42 8.77-18.395 6.843l.092-.595c9.46 2.027 18.002-6.856 18.028-6.881l.236.215c.013.102.026.203.04.292v.127ZM30.317 80.138c-2.218 2.015-9.12 7.578-16.834 6.5a9.018 9.018 0 0 0-.184-.633c8.227 1.292 15.588-5.36 17.044-6.754 0 .304-.013.596-.026.887Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#70B4F5",
    d: "m13.102 85.473 1.6-3.206 2.139 3.485 1.837-4.245 2.532 3.27 1.312-4.55 2.677 2.788 1.22-5.183 1.995 2.902 1.666-6.082c.04.24.066.494.092.735.013.088.013.177.026.253l-1.64 5.956-1.968-2.877-1.181 5.03-2.703-2.812-1.338 4.638-2.598-3.346-1.863 4.321-2.165-3.522-1.457 2.927a3.088 3.088 0 0 0-.144-.368l-.04-.114Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#70B4F5",
    d: "M14.846 84.915c.17.013.315.165.315.342a.288.288 0 0 1-.315.292.349.349 0 0 1-.315-.342c0-.178.131-.304.315-.292ZM16.749 83.052c.17.013.315.165.315.342a.288.288 0 0 1-.315.292.349.349 0 0 1-.315-.342c-.013-.178.131-.304.315-.292ZM18.966 84.434c.17.012.315.165.315.342a.288.288 0 0 1-.315.291.348.348 0 0 1-.315-.342c0-.177.145-.304.315-.291ZM20.843 82.026c.17.013.315.165.315.342a.288.288 0 0 1-.315.291.348.348 0 0 1-.315-.342c0-.164.144-.304.315-.291ZM23.204 82.926c.17.013.315.165.315.342a.288.288 0 0 1-.315.291.348.348 0 0 1-.315-.342c0-.164.131-.304.315-.291ZM24.608 80.278c.17.012.315.164.315.342a.288.288 0 0 1-.315.291.348.348 0 0 1-.314-.342c0-.177.13-.304.314-.291ZM26.983 80.835c.17.013.315.165.315.342a.288.288 0 0 1-.315.292.349.349 0 0 1-.315-.343c0-.177.131-.304.315-.29ZM28.243 77.946c.17.013.315.165.315.342a.288.288 0 0 1-.315.291.348.348 0 0 1-.315-.342c0-.164.144-.304.315-.291ZM30.263 78.25c.026 0 .053.013.079.013v.608c-.026 0-.053.013-.079 0a.349.349 0 0 1-.315-.342c0-.152.145-.292.315-.279ZM12.734 83.116c.17.013.315.165.315.342a.288.288 0 0 1-.315.292.349.349 0 0 1-.315-.342c0-.178.144-.305.315-.292Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#3469C0",
    d: "M14.675 77.072c.473 2.47-.13 6.665-1.39 8.87-.617-1.508-1.142-2.649-1.982-4.068.066-.177 2.782-7.856 3.372-4.802Z",
    opacity: 0.35
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M13.836 95.724c.577.292 1.6.545 2.02.748.224.101 1.772.912 2.651 1.406.945.532 1.246 1.356 1.85 2.256.433.735.643 1.28.722 1.66.078.393-.906 1.216-1.352 1.153-1.023-.152-2.125-1.28-2.4-1.394-2.323-.988-3.412-1.026-4.278-1.875-.368-.355-.656-1.47-1.444-2.433l1.3-1.293.931-.228Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M8.443 73.942c-2.06 3.206-3.556 9.035-5.393 12.988a2.247 2.247 0 0 0-.236.836c-.34.976.197 1.8.893 2.674 1.718 2.129 3.096 4.055 6.639 6.602.262.19.55.19.931.266.223.152.538.444.774.608-.301-.33 1.247-2.204 2.021-2.128-.21-.216-.42-.457-.643-.723-.052-.33-.066-.545-.223-.823-.617-1.154-2.703-3.98-4.697-6.007.826-1.039 1.522-2.242 2.1-3.091 1.023-1.508 1.928-3.067 2.741-4.575.328-.608.499-.9.814-1.52 2.283-4.613-3.202-8.985-5.72-5.107Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M23.322 68.227c.04-.19.092-.38.131-.596.118-.595-.04-1.736.131-3.091l-5.3-2.167c-.092 2.876-.578 3.472-1.129 5.816.066 2.306 5.983 3.333 6.115.634 0-.203.013-.406.052-.596Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M23.323 68.227c.039-.19.091-.38.13-.596.119-.595-.039-1.736.132-3.091l-5.3-2.167a23.202 23.202 0 0 1-.119 1.66c-.184 1.9 1.706 5.22 5.104 4.79 0-.203.013-.406.053-.596Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M23.624 68.088c-.656-.418-2.427-1.458-3.018-1.876-1.272-.9-1.115-2.053-1.495-3.865-1.194-.823-1.588-1.482-1.706-2.217-.25-1.749.787-3.637 2.165-4.676 1.207-.9 2.61-1.153 4.172-.824 3.044.647 4.304 2.864 4.461 5.411.014.216-.013.418-.091.634-.171.507-.21.583-.276.95-.157.76.367 1.026.157 1.964-.288 1.28-1.377 3.764-1.823 4.182-.328.33-1.864.43-2.546.317Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M28.073 58.951c.078.355.118.735.144 1.103a1.52 1.52 0 0 1-.092.633c-.17.507-.21.583-.276.95-.157.76.368 1.027.158 1.965-.145.62-.473 1.52-.827 2.344-1.955 1.444-3.674-.317-3.936-.646-1.233-1.534-1.325-3.814-.394-5.956 1.417.456 3.74.367 5.223-.393Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#562E65",
    d: "M16.579 59.319c.079.975.866 3.472 1.47 4.397.616.963.354-.216.669-.875.249-.506 1.062-.557 1.312-1.09.118.444.275.875.577 1.027.184.101.564.24.577-.291.053-1.8.932-1.927.656-3.016-.21-.811-.157-1.153.053-1.457.603.076.997.684 1.719.988.498.203 2.69.43 4.25-.393 1.51-.798 1.64-2.56.381-3.7-.708-.633-1.495-.798-2.598-1.508-2.112-1.356-4.736-.874-6.166.634-2.782.557-3.084 3.104-2.9 5.284Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M19.517 60.84c-1.155-.508-1.286.823-1.194 1.647.066.557.551.57.67 1.013.157.532.537.824.905.85.721.05.38-1.027.34-1.445.158-.684.014-1.749-.721-2.066Z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M22.666 57.165c-.105.747.892 1.634 2.31 1.71 1.312.064 3.083-.228 3.739-1.761.236-.545-.052-1.495-.682-1.9-.433-.267-.998-.242-1.575.012-.97.405-1.771 1.457-2.466 1.71-.67.241-1.313.14-1.326.229Z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M149.86 75.285c-1.732-.253-3.096.887-3.778 2.42-.814 1.787-.775 4.119-.42 5.335 1.128 3.954-.853 5.677-1.588 7.527-.328.81-.459 1.875-.42 3.054.053 1.419.892 2.141 1.601 3.421.184 1.293.512 2.496 1.037 3.51 1.941 3.751 8.489 5.563 14.761 5.297 5.025-.228 9.88-1.939 12.071-3.916 2.414-2.167 2.729-7.666-1.325-8.224-.945-.126-2.047-.329-2.848-1.267-.551-.646-.013-2.357.118-4.637.132-2.205-.393-4.524-3.713-5.297-1.273-.292-2.506-.418-3.569-1.09-2.322-1.47-1.469-4.194-3.975-5.803-1.522-.976-3.963-1.179-6.626-.47-.446.039-.879.09-1.326.14Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#22043D",
    d: "M148.365 77.363c-.145 1.077.262 2.015.931 2.914 1.548 2.104 2.362 1.939 3.202 4.625 1.39-.9 2.348-1.026 2.742-.152.643 1.42.236 2.256.394 3.713.249 2.382 3.188-.887 5.497.938 2.27 1.787.709 3.054 1.588 5.588.328.95.577 2.192 1.496 2.623 2.86 1.305 3.949 4.587-1.129 6.222-3.149 1.013-7.715.76-11.533-.495-5.038-1.659-8.148-8.844-6.862-12.253.538-1.406 1.968-2.47 1.981-3.573 0-3.802-.761-6.235 1.693-10.15Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#B)",
    d: "M125.494 80.721c-.774.241-.367 1.103-.065 1.343.446.431 1.338.697 1.259 1.154-.092.506 2.808 1.47 2.795 1.431-.42-1.356-1.168-2.154-1.325-2.255-1.562-1.014-1.378-.368-2.664-1.673Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M127.515 86.474c1.653 2.141 2.965 6.272 4.632 8.186.525.608 1.312 1.61 2.217 1.457 4.724-.798.42-2.56.932-3.801-.801-2.687-4.173-4.182-5.563-7.147a5.207 5.207 0 0 0-.25-.596c-.577-1.127-1.115-1.47-3.346-1.875-.642-.114-.865-.33-1.259-.634l-1.457-1.394c-.485-.38-.892-.506-1.089-.405-.223.114-.826 1.23-.839 1.825-.079.228.17.633.748 1.064l1.81 2.446.158.025c2.007.254 2.808.444 3.306.849Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#C)",
    d: "M135.086 97.03c3.267-.318 7.952-.812 10.471-2.066 1.64-.824 4.605-4.334 2.939-6.285-.354-.913-3.503 1-5.052 1.57-2.808 1.027-4.658 1.509-7.557 2.231-.788-2.141-2.874-3.827-4.527-5.816a2.591 2.591 0 0 0-.918-.722c-.21-.228-.368-.495-.525-.76-.276-.115-2.047.595-2.52 1.444.132.165.407.532.525.722.171.266.132.583.276.887.472 1.014 2.729 5.449 4.238 7.185.577.659 1.404 1.825 2.401 1.66.092-.025.171-.038.249-.05Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#7E41DF",
    d: "M135.086 97.03c3.267-.317 7.952-.812 10.471-2.066 1.417-.71 3.831-3.421 3.372-5.411-.617-.557-.984-.849-1.496-.836-.656.025-1.443.71-2.939 1.457-2.27 1.14-4.422 1.191-6.18 3.206-1.299 1.482-3.464 2.762-5.301 2.712.499.557 1.129 1.102 1.824.988.092-.025.171-.038.249-.05Z",
    opacity: 0.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#EEFAEC",
    d: "m138.117 171.69 20.586-11.315c2.244-.989 5.459-1.774 7.742-.634 2.086 1.052 5.511 3.193 7.033 4.03 1.154.633 5.156 2.952 2.663 4.257-7.334 3.852-14.59 8.173-22.03 12.089-1.404.735-3.464 1.001-5.629.836-2.152-.177-4.356-.773-6.101-1.748-1.233-.697-2.454-1.382-3.648-2.053-1.613-.913-2.466-1.977-2.558-2.978-.079-.976.564-1.875 1.942-2.484Z",
    opacity: 0.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M160.147 155.509c-.105.468.197 1.153.249 1.229 1.194 1.672-.223 1.533-.17 3.915 0 .216-1.011 3.992-1.011 3.992s-2.375.557-2.558.532c-.184-.025-1.627-.57-1.627-.57.118-.203.288-.697.38-.887.683-1.293 1.05-2.851 1.312-4.423.171-1.039.499-2.648.276-3.738l3.149-.05Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#161F69",
    d: "M154.978 164.581c-.328.621-.499 1.04-.669 1.521-.079.241-.066.482.026.621.538.76 3.451-.494 4.435-1.28.643-.507.669-1.128.839-1.888.263-1.14.302-1.267.63-2.433l.21 3.193.263.165c.105-1.292.301-3.003.551-4.105.091-.444.262-.938.288-1.179.171-1.444-.551-2.179-1.207-2.598.223.887-.59 2.294-.958 4.081-.446 2.154-2.427 3.915-4.408 3.902Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#D)",
    d: "M144.468 111.475c.223.976-.814 4.372-.551 5.677.249 4.295 1.036 7.919 4.028 16.511 0 .101 2.729 5.347 2.913 5.892 1.863 5.601 4.185 11.683 6.167 17.335.734.545 2.952.38 3.227-.951-.616-5.651.053-11.227-.944-15.091-.761-2.94-1.772-4.283-3.412-6.476-.498-5.55-.866-16.688-2.178-20.958l-9.25-1.939Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E2353",
    d: "M144.467 111.475c.223.976.893 2.8 1.168 4.105.84 1.977 2.598 4.676 3.779 6.957.354 2.75.262 6.412 2.034 11.519l1.613 11.797c1.326 3.7 2.717 7.451 3.976 11.037.735.545 2.952.38 3.228-.951-.617-5.651.052-11.227-.945-15.091-.761-2.94-1.771-4.283-3.411-6.476-.499-5.55-.866-16.688-2.178-20.958l-9.264-1.939Z",
    opacity: 0.3
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M157.812 161.236c-.053.519.197 1.052.262 1.571.092.786.21 1.685.171 2.775a23.822 23.822 0 0 1-.643 4.993c-.171.697-.486.988-.695 1.938l-4.239.672c.42-1.546.998-4.688 1.431-7.311l.813-4.917 2.9.279Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#161F69",
    d: "M158.022 162.529c.249.823.525 1.254.564 2.382.04 1.128-.498 2.876-.459 4.257l.066 2.205c.039 1.28-.302 2.18-1.811 3.232-1.365.963-2.703 1.355-3.425 1.013-.538-.253-.957-1.165-.144-3.56.682-2.003.853-3.954 1.26-6.121-.145 2.129-.197 2.839-.722 4.929-.144.583-.236 1.559.485 1.66 2.966.406 3.11-.354 3.359-1.241.656-2.345 1.129-6.552.827-8.756Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#E)",
    d: "M159.111 114.858c3.293 3.979 3.372 6.184 2.663 10.974-.472 3.193-1.443 7.083-1.692 12.697.288 2.902.826 6.146.407 10.657-.302 3.32-1.26 8.996-1.995 13.013-.682 1.242-3.923.697-4.448.064.158-5.766.053-9.707-.223-14.357-.275-4.524-.84-8.718-1.181-13.191-.288-3.688-1.456-8.718-1.601-12.71-.616-1.875-6.442-8.11-5.235-8.034l13.305.887Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#F)",
    d: "M158.716 105.899c-1.482 3.308 1.037 5.132.132 7.413l.275 1.546c-2.703 1.875-12.347 2.015-14.774-1.698l-.053-1.85c-.419-.887-.144-3.13-.026-3.713.394-1.875.21-2.876.42-5.043.053-.545.158-.9.21-1.457-2.152-1.546-2.008-4.55-.735-6.349.801-1.127 1.273-1.951 1.667-2.85.118-.685.249-1.255.367-1.635.079-.317.262-.621.446-.887.617-.85 1.601-.95 3.635-.495 4.015.887 8.148 2.902 9.998 4.803 1.338 1.381 1.286 2.914.525 6.222-.486 2.116-1.339 4.321-2.087 5.993Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#7E41DF",
    d: "M158.744 105.887c-1.483 3.307.97 5.195.065 7.463l.276 1.521c-2.703 2.027-12.347 1.926-14.774-1.774l.052-1.609c0-.064 4.737 4.054 10.129 1.761 1.168-.494 2.231-2.978.722-7.704-.144-.457-1.863-.482-4.304-2.218 1.798.735 5.183 1.749 5.354-2.674.078-1.976.38-3.459 1.417-4.828.511-.671 3.477 2.826 3.031 4.499a39.017 39.017 0 0 1-1.968 5.563Z",
    opacity: 0.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#G)",
    d: "M160.03 113.198c-.486.292-1.391.57-1.745.773-.184.102-1.522.913-2.27 1.394-.801.52-1.024 1.267-1.509 2.104-.341.684-.486 1.178-.538 1.507-.053.355.879 1.027 1.273.951.892-.19 1.81-1.255 2.047-1.369 2.007-1.001 2.965-1.102 3.687-1.9.314-.343.498-1.344 1.141-2.231l-1.233-1.077-.853-.152Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#H)",
    d: "M160.265 93.43c2.978 1.813 6.258 6.805 9.211 11.24.577.723.433 1.673.118 2.205-.118.292-.315.621-.578 1.001-1.403 1.99-2.768 3.764-5.76 6.209-.223.191-.538.267-.866.355-.183.152-.446.418-.656.583.25-.304-1.233-1.863-1.915-1.749.17-.202.354-.43.525-.671.026-.292 0-.482.118-.735.971-2.142 2.217-4.296 3.765-5.93-2.676-2.801-4.225-3.485-6.718-6.425-3.031-3.573.788-7.286 2.756-6.082Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M154.072 86.12c-.315 1.71-.144 3.32.407 4.98-1.443 1.292-4.015.747-4.619-.432.132-.76.276-1.457.355-2.23l3.857-2.319Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#I)",
    d: "M154.072 86.12a10.042 10.042 0 0 0-.131 2.407c-.42 1.66-3.634 2.775-3.962 1.457.091-.507.183-1.014.236-1.546l3.857-2.319Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFA698",
    d: "M148.089 78.897c-.722 1.102-1.102 2.217-.945 3.788.04.406-.013.647-.131.913-.669 1.47-.617 1.926-.276 3.104.329 1.14.302 1.749.709 2.142.42.405 1.037.494 1.561.532 1.076.063 2.939-.621 4.015-1.191.801-.418.775-.71 1.103-1.445 1.128-.95.393-1.634.013-1.71-1.089-.203-1.26 1-1.903 1.267.118-2.13-4.067-5.703-4.146-7.4Z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#J)",
    d: "M147.603 79.745c-.406.85-.59 1.761-.459 2.94.04.405-.013.646-.131.912-.669 1.47-.617 1.926-.276 3.105.145.52.224.912.302 1.242a1.05 1.05 0 0 0 1.26.354c.446-.19.892-.71 1.01-1.57.079-.61 1.378-1.015 1.64-1.635.223-.52-.38-1.09-.734-1.382-1.286-1.039-2.074-2.445-2.612-3.966Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8F7F",
    d: "M148.089 78.897c.604 2.597 4.12 4.574 4.159 7.4-.971-2.94-4.382-4.955-4.159-7.4Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 103.122,
    x2: 111.522,
    y1: -3.773,
    y2: 20.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD90DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6DFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 108.628,
    x2: 84.903,
    y1: 54.001,
    y2: 146.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E0F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E8F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 125.587,
    x2: 39.484,
    y1: 101.76,
    y2: 52.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 77.513,
    x2: 89.36,
    y1: 93.253,
    y2: 67.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 115.411,
    x2: 124.156,
    y1: 108.885,
    y2: 95.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 119.326,
    x2: 113.915,
    y1: 96.315,
    y2: 108.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD90DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6DFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 94.613,
    x2: 107.772,
    y1: 142.476,
    y2: 118.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 106.608,
    x2: 95.786,
    y1: 146.513,
    y2: 106.722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C8EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#00CFDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 57.889,
    x2: 62.703,
    y1: 94.603,
    y2: 119.901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD70CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E4DFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 52.193,
    x2: 55.043,
    y1: 115.045,
    y2: 104.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 130.326,
    x2: 137.6,
    y1: 57.749,
    y2: 36.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 145.784,
    x2: 139.938,
    y1: 31.325,
    y2: 54.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 74.392,
    x2: 71.817,
    y1: 46.797,
    y2: 21.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 61.305,
    x2: 62.47,
    y1: 25.023,
    y2: 15.317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 47.34,
    x2: 48.656,
    y1: 29.907,
    y2: 24.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 51.283,
    x2: 51.612,
    y1: 75.544,
    y2: 79.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 51.576,
    x2: 51.848,
    y1: 75.292,
    y2: 78.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 32.293,
    x2: 36.922,
    y1: 68.56,
    y2: 81.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 27.867,
    x2: 20.305,
    y1: 101.763,
    y2: 127.062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 23.202,
    x2: 9.072,
    y1: 103.292,
    y2: 132.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#235DA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#123A76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: 18.755,
    x2: 23.127,
    y1: 71.897,
    y2: 95.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: 15.727,
    x2: 16.724,
    y1: 100.644,
    y2: 98.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 7.871,
    x2: 10.455,
    y1: 76.608,
    y2: 96.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FB0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 21.176,
    x2: 19.852,
    y1: 65.151,
    y2: 66.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 25.811,
    x2: 24.203,
    y1: 60.766,
    y2: 64.876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 26.66,
    x2: 25.443,
    y1: 57.68,
    y2: 56.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A4791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#562E65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 160.63,
    x2: 154.758,
    y1: 88.178,
    y2: 99.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A2D68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22043D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    x1: 126.988,
    x2: 127.399,
    y1: 83.016,
    y2: 82.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    x1: 129.512,
    x2: 144.492,
    y1: 92.018,
    y2: 88.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    x1: 147.364,
    x2: 160.618,
    y1: 120.034,
    y2: 146.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    x1: 144.348,
    x2: 165.022,
    y1: 125.277,
    y2: 149.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#273088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    x1: 150.222,
    x2: 153.076,
    y1: 111.577,
    y2: 94.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "G",
    x1: 158.482,
    x2: 157.833,
    y1: 117.573,
    y2: 116.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "H",
    x1: 164.846,
    x2: 161.454,
    y1: 109.424,
    y2: 94.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#965CF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8ADC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "I",
    x1: 152.107,
    x2: 152.382,
    y1: 88.485,
    y2: 89.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "J",
    x1: 146.884,
    x2: 149.034,
    y1: 82.958,
    y2: 86.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB89E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA799"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataMigration);
export default __webpack_public_path__ + "static/media/data-migration.89417067a2ef64eb614e0a199fa6b170.svg";
export { ForwardRef as ReactComponent };